<template>
  <div class="card px-2 py-2 mt-3 wrapper-hgsi" v-if="true">
    <div>
      <button class="btn" style="box-shadow: none;" @click="visible = !visible">
        <i class="fab fa-buffer"></i>
        NPS Ponderado
      </button>
      <button class="btn pull-right" style="box-shadow: none;" @click="visible = !visible">
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div class="card" v-if="loader">
      <div style="height: 230px;">
        <!-- <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner variant="primary" type="grow" :label="`${this.$t('reports.loadingLabel')}...`"></b-spinner>
        </div> -->
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" class="mt-2">
        <div v-if="items.length > 0">
          <div style="display: flex;" class="hgsi-chart-table">
            <div class="hgsi-chart col-3">
              <radial-progress-bar v-if="totalPonder !== null && totalPonder !== undefined" :diameter="240"
                :stroke-width="20" innerStrokeColor="#f1f1f1" :startColor="colorBalance" :stopColor="colorBalance"
                :completed-steps="totalPonder ? parseInt(totalPonder / 100) : 0" :total-steps="100">
                <b id="nps-ponder" :style="{
                  color: colorBalance,
                  fontSize: '2.8em',
                  fontWeight: 'bold',
                }">{{ (totalPonder / 100).toFixed(1) }}

                </b>
              </radial-progress-bar>
              <div v-else>
                Sem dados para exibir
              </div>
            </div>
            <b-table :items="items" caption-bottom :fields="fields" sort-icon-left class="table-nps-ponder">

              <template v-slot:cell(totalWeight)="row">{{ (row.item.totalWeight).toFixed(2) }}%</template>
              <template v-slot:cell(promoters)="row">{{ percentilPromoters(row.item) }}%</template>
              <template v-slot:cell(neutrals)="row">{{ percentilPassive(row.item) }}%
              </template>
              <template v-slot:cell(detractors)="row">{{ percentilDetractors(row.item) }}%</template>
              <template v-slot:cell(nps)="row">
                {{ (row.item.nps).toFixed(1) }}
              </template>

            </b-table>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';

export default {
  name: 'NpsPonder',
  components: {
    RadialProgressBar,
    animatedNumber,
  },

  props: ['showCollapsed', 'npsPonderData', 'weightedNpsType'],

  data: () => ({
    filter: null,
    userAuth: null,
    visible: true,
    page: 1,
    limit: 10,
    loader: false,
    items: [],
    fields: [],
    respostas: [],
    colorBalance: '#000',
    totalPonder: 0,
  }),

  watch: {
    actionGroupData: function watchActionGroupData() {
      this.loadData();
    },
    myActionId: function watchMyActionId() {
      this.loadData();
    },
    myIh1: function watchMyIh1() {
      this.loadData();
    },
    myIh2: function watchMyIh2() {
      this.loadData();
    },
    calendarDates: function watchDates() {
      this.loadData();
    },
    myMetric: function watchMyMetric() {
      this.loadData();
    },
    'indicatorData.value': function watchMyMetric() {
      this.loadData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.loadData();
    },
  },

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'allActions']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'ih1']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  methods: {
    async loadData() {

      this.items = this.npsPonderData;
      this.totalPonder = 0;
      this.items.map(a => {
        this.totalPonder += a.npsPonder;
      })

      this.setColorNps(this.totalPonder);

    },
    percentilPassive({ promoters, neutrals, detractors }) {
      const total = promoters + neutrals + detractors;
      let result;
      if (total > 0) {
        result = parseFloat(((neutrals / total) * 100).toFixed(1));
      } else {
        return 0;
      }
      return result;
    },

    percentilDetractors({ promoters, neutrals, detractors }) {
      const total = promoters + neutrals + detractors;
      let result;
      if (total > 0) {
        result = parseFloat(((detractors / total) * 100).toFixed(1));
      } else {
        return 0;
      }
      return result;
    },

    percentilPromoters({ promoters, neutrals, detractors }) {
      const total = promoters + neutrals + detractors;
      let result;
      if (total > 0) {
        result = parseFloat(((promoters / total) * 100).toFixed(1));
      } else {
        return 0;
      }
      return result;
    },
    setColorNps(percentBalace) {
      if (this.myMetric.indexOf('nps') !== -1) {
        if (percentBalace >= 80) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 80 && percentBalace >= 70) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 70 && percentBalace >= 50) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 50 && percentBalace >= 0) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 0) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('ces') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace <= 1) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('csat') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('stars') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      } else if (this.myMetric.indexOf('like-dislike') !== -1) {
        if (percentBalace >= 4) {
          this.colorBalance = '#6bca6c';
        } else if (percentBalace < 4 && percentBalace >= 3) {
          this.colorBalance = '#9fd77a';
        } else if (percentBalace < 3 && percentBalace >= 2) {
          this.colorBalance = '#fbcf3f';
        } else if (percentBalace < 2 && percentBalace >= 1) {
          this.colorBalance = '#fa834f';
        } else if (percentBalace < 1) {
          this.colorBalance = 'red';
        }
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.fields = [
      {
        key: 'groupName',
        label: this.weightedNpsType === 'actions' ?
          this.$t('reports.npsPonder.groupAction') :
          this.$t('reports.npsPonder.channel'),
      },
      {
        key: 'totalWeight',
        label: this.$t('reports.npsPonder.weight'),
      },
      {
        key: 'answers',
        label: this.$t('reports.npsPonder.answers'),
      },
      {
        key: 'promoters',
        label: this.$t('reports.npsPonder.promoters'),
      },
      {
        key: 'neutrals',
        label: this.$t('reports.npsPonder.passive'),
      },
      {
        key: 'detractors',
        label: this.$t('reports.npsPonder.detractors'),
      },
      {
        key: 'nps',
        label: 'NPS',
      },
    ];

    this.loadData();
  },

  mounted() {
    this.visible = this.showCollapsed;
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';

.no-padding {
  padding: 0;
}

.table {
  margin: 0;
}

.wrapper-hgsi .table>thead>tr:nth-child(2) {
  display: none;
}

.wrapper-hgsi .btn .btn-light .collapsed {
  background-color: transparent;
}

.card {
  border: 1px solid rgba(0, 0, 0, 0.09);
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;

  transition: color 0.2s;

  &:hover {
    color: #1dc86e;
  }
}

.hgsi-chart {
  display: flex;
  justify-content: center;
  align-items: center;
  //height: calc(100% - 30px);
}

.hgsi-chart-table {
  font-size: 70%;
}



</style>
<style>
.hgsi-chart-table.table th, .table td {
  padding: 5px;
}

.progressHgsi {
  width: 400px;
}

.scoreHgsi {
  width: 70px;
  padding-right: 0px !important;
}

.totalHgsi {
  width: 70px;
  padding-right: 0px !important;
}

.questionHgsi {
  width: calc(100% - 500px);
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/nps-ponder/index.vue